// noinspection JSUnusedGlobalSymbols

export default class
{
	static pen_color = '#555'

	static canvases = new Map()

	static canvas_modified = new Set()

	static sign_canvas_modified = false

	static init()
	{
		this.canvases = new Map()
		this.canvas_modified = new Set()
		this.sign_canvas_modified = false

		if($('#sign').length > 0)
		{
			this.sign_canvas = new fabric.Canvas('sign')

			this.sign_canvas.isDrawingMode = true
			this.sign_canvas.freeDrawingBrush.width = 3
			this.sign_canvas.freeDrawingBrush.color = this.pen_color

			this.sign_canvas.on('path:created', () => this.sign_canvas_modified = true)

			this.sign_canvas.on('mouse:down', () =>
			{
				if(!this.sign_canvas_modified) this.sign_canvas.clear()
			})

			const image = new Image()

			image.onload = () =>
			{
				this.sign_canvas.getContext('2d').drawImage(image, 0, 0)
				$('#sign_input').val(this.sign_canvas.toDataURL())
			}

			image.src = `/sign/${$('#sign').data('customer')}`
		}

		$('canvas[data-acceptance]').each((index, element) =>
		{
			const acceptance = Number(element.dataset.acceptance)
			const canvas = new fabric.Canvas(element.id)

			canvas.isDrawingMode = true
			canvas.freeDrawingBrush.width = 3
			canvas.freeDrawingBrush.color = this.pen_color

			canvas.on('path:created', () => this.canvas_modified.add(acceptance))

			canvas.on('mouse:down', () =>
			{
				if(!this.canvas_modified.has(acceptance)) canvas.clear()
			})

			this.canvases.set(acceptance, canvas)

			fabric.Image.fromURL(`/agreement_sign/${acceptance}`, image =>
			{
				canvas.setBackgroundImage(image, () =>
				{
					canvas.renderAll()
					$(`[data-sign="${acceptance}"]`).val(canvas.toDataURL())
				}, {
					scaleX: canvas.width / image.width,
					scaleY: canvas.height / image.height,
				})
			})
		})
	}

	static clear_agreement_sign(acceptance)
	{
		this.canvases.get(acceptance).clear()
		this.canvas_modified.delete(acceptance)
		$(`[data-sign="${acceptance}"]`).val('')
	}

	static send_agreement_sign(form)
	{
		const acceptance = Number($('[name="id"]', form).val())

		if(this.canvas_modified.has(acceptance))
		{
			$(`[data-sign="${acceptance}"]`).val(this.canvases.get(acceptance).toDataURL())
		}

		return App.common.Network.form_post(form)
	}

	static clear_sign()
	{
		this.sign_canvas.clear()
		$('#sign_input').val('')
	}

	static send_sign(form)
	{
		if(this.sign_canvas_modified) $('#sign_input').val(this.sign_canvas.toDataURL())
		return App.common.Network.form_post(form)
	}

	static check_target(target)
	{
		$('#check').attr('href', `/customer/${target}`)
	}

	static select_target(id)
	{
		$('#merge')[0].tomselect.setValue(id)
	}
}
